import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import bgImage from "../../assets/images/aboutus-bg.png";
import about_img_3 from "../../assets/images/about-us-copy.png";
import about_img_2 from "../../assets/images/inside.284eea6870742af2d60f.webp";
import about_img_1 from "../../assets/images/fronhospital.1ce20f9a24226e1f7302.jpg";
import circular from "../../assets//images/gol-photo.png";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
const HomePageAbout = () => {
  const [showVideo, setShowVideo] = useState(false);
  useEffect(() => {
    if (showVideo) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showVideo]);
  return (
    <div
      className="pt-[200px] pb-[190px]  w-full flex justify-center bg-[#F6F9FF]  items-center"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex lg:flex-row flex-col w-[95%] xl:w-4/5 2xl:w-8/12 ">
        {/* Video Modal Overlay */}
        {showVideo && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
            {/* Video Container with animation */}
            <div className="relative w-full max-w-5xl 2xl:max-w-screen-2xl p-4 animate-fade-in">
              {/* Close Button */}
              <button
                className="absolute -top-6 xl:top-3 right-3 xl:-right-5 text-white hover:text-red-500 transition-colors z-50"
                onClick={() => setShowVideo(false)}
              >
                <CloseIcon fontSize="large" />
              </button>

              {/* Responsive iframe wrapper */}
              <div className="w-full h-0 pb-[56.25%] relative overflow-hidden rounded-xl shadow-2xl animate-scale-in">
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/LSR4pyiLfZQ?si=RLijmsUxv8hSP7Vy"
                  title="Video Player"
                  frameBorder="0"
                  allow="autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        )}
        {/* fist div  */}
        <div className="flex flex-row gap-6 lg:w-1/2 w-full justify-center relative">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:p-0 p-8 z-10">
            <div className="relative inline-block">
              <img src={circular} alt="centered" />

              {/* Centered Play Button on Top */}
              <p
                onClick={() => setShowVideo(true)}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-md cursor-pointer"
              >
                <PlayArrowIcon
                  className="text-5xl text-blue-600"
                  fontSize="30px"
                />
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-4 justify-center">
            <div className="w-[266px] ">
              <img
                src={about_img_1}
                className="rounded-xl object-cover  hover:-translate-y-2 transition-all hover:duration-500"
                alt="about us_image"
              />
            </div>
            <div className="w-[266px] ">
              <img
                src={about_img_2}
                className="rounded-xl hover:-translate-y-2 object-cover transition-all hover:duration-500"
                alt="about us_image"
              />
            </div>
          </div>
          <div className=" justify-center items-center md:flex hidden">
            <img
              src={about_img_3}
              className="rounded-xl hover:-translate-y-2 transition-all hover:duration-500"
              alt="about us_image3"
            />
          </div>
        </div>

        {/* Second Div  */}

        <div className="lg:w-1/2 w-full flex flex-col gap-3  justify-center lg:mt-0 mt-12 text-left pl-3  md:pl-11">
          <div className="text-[16px] w-full  font-outfit text-left font-normal text-[#243FFA]">
            ABOUT US
          </div>

          <h2 className="xl:text-[52px] text-[32px] font-outfit text-[#212529] text-left font-semibold leading-[1.1em] ">
            Welcome to MagnAid Hospital & Healthcare
          </h2>
          <p className="text-lg font-basic font-outfit my-3 text-[#212529] mr-12 pb-2.5">
            Donec pulvinar tellus egetmagna aliquet ultricies. nec eleifend sem
            convallis vitae soluta nobis est eligendi optio cumque nihio ruo
            minus id quod maxime placeat facere.
          </p>
          <div className="flex md:flex-row flex-col justify-start w-full">
            <div className="md:w-1/2 w-full">
              <ul>
                <li className="flex flex-row justify-start items-center gap-2 text-[#0F2349] text-lg font-outfit transition-all hover:cursor-text mb-1 hover:duration-200 font-[400] w-full hover:text-blue-600 group">
                  <CheckCircleIcon
                    className=" flex-shrink-0 text-blue-600 text-xl group-hover:text-[#0F2349] transition-all group-hover:duration-200"
                    fontSize="80px"
                  />{" "}
                  Monthly Checkups
                </li>
                <li className="flex flex-row justify-start items-center gap-2 text-[#0F2349] text-lg font-outfit transition-all hover:cursor-text mb-1 hover:duration-200 font-[400] w-full hover:text-blue-600 group">
                  <CheckCircleIcon
                    className=" flex-shrink-0 text-blue-600 text-xl group-hover:text-[#0F2349] transition-all group-hover:duration-200"
                    fontSize="80px"
                  />{" "}
                  Caring Medical Team
                </li>
                <li className="flex flex-row justify-start items-center gap-2 text-[#0F2349] text-lg font-outfit transition-all hover:cursor-text mb-1 hover:duration-200 font-[400] w-full hover:text-blue-600 group">
                  <CheckCircleIcon
                    className=" flex-shrink-0 text-blue-600 text-xl group-hover:text-[#0F2349] transition-all group-hover:duration-200"
                    fontSize="80px"
                  />{" "}
                  Proactive and Fast Results
                </li>
              </ul>
            </div>

            <div className="md:w-1/2 w-full">
              <ul>
                <li className="flex flex-row justify-start items-center gap-2 text-[#0F2349] text-lg font-outfit transition-all hover:cursor-text mb-1 hover:duration-200 font-[400] w-full hover:text-blue-600 group">
                  <CheckCircleIcon
                    className=" flex-shrink-0 text-blue-600 text-xl group-hover:text-[#0F2349] transition-all group-hover:duration-200"
                    fontSize="80px"
                  />{" "}
                  Cosmetic Filling
                </li>
                <li className="flex flex-row justify-start items-center gap-2 text-[#0F2349] text-lg font-outfit transition-all hover:cursor-text mb-1 hover:duration-200 font-[400] w-full hover:text-blue-600 group">
                  <CheckCircleIcon
                    className=" flex-shrink-0 text-blue-600 text-xl group-hover:text-[#0F2349] transition-all group-hover:duration-200"
                    fontSize="80px"
                  />{" "}
                  Dental X-Ray
                </li>
                <li className="flex flex-row justify-start items-center gap-2 text-[#0F2349] text-lg font-outfit transition-all hover:cursor-text mb-1 hover:duration-200 font-[400] w-full hover:text-blue-600 group">
                  <CheckCircleIcon
                    className=" flex-shrink-0 text-blue-600 text-xl group-hover:text-[#0F2349] transition-all group-hover:duration-200"
                    fontSize="80px"
                  />{" "}
                  Complete Crown
                </li>
              </ul>
            </div>
          </div>
          <div className="text-left mt-3">
            <a
              href="1"
              className="text-blue-600 font-outfit text-xl hover:text-black flex justify-start gap-5 font-bold items-center group "
            >
              Read More
              <span className="text-sm  group-hover:bg-white border-[1px] border-blue-600 rounded-full p-4  flex justify-center items-center h-12 w-12 text-blue-600 transition-all hover:duration-200 group-hover:text-black">
                <ArrowOutwardIcon className="text-sm" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageAbout;
